import {
  create_franchisee_c_z_record,
  delete_franchisee_c_z_record,
  query_franchisee_c_z_record_list,
} from '@/api/jms-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/jms/jms-franchiseeczrecord-config';

import { reactive } from 'vue';
import { get_is_active, getDateTime, toFixed0 } from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '充值编码',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写充值编码',
    },
    {
      type: 'remotemodal',
      name: 'franchisee_id',
      label: '加盟商',
      disabled: false,
      placeholder: '请选择加盟商',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-franchisee',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-companystaff',
    },
    {
      type: 'remoteselect',
      name: 'sk_type_id',
      label: '支付方式',
      disabled: false,
      placeholder: '请选择支付方式',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-sktype',
    },
    {
      type: 'remoteselect',
      name: 'cxzc_id',
      label: '促销政策',
      disabled: false,
      placeholder: '请选择促销政策',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-policy',
    },
    {
      type: 'datepicker',
      name: 'date',
      label: '收款日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM-DD HH:mm:ss',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      showTime: true,
      placeholder: '请选择收款日期',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    code: null,
    franchisee_id: null,
    staff_id: null,
    sk_type_id: null,
    cxzc_id: null,
    date: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'franchisee_id',
      label: '加盟商',
      disabled: false,
      placeholder: '请选择加盟商',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-franchisee',
    },
    {
      type: 'input',
      name: 'price',
      label: '收款金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写收款金额',
    },
    {
      type: 'input',
      name: 'cz_flje',
      label: '返利金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写返利金额',
    },
    {
      type: 'remoteselect',
      name: 'sk_type_id',
      label: '支付方式',
      disabled: false,
      placeholder: '请选择支付方式',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-sktype',
    },
    {
      type: 'remoteselect',
      name: 'cxzc_id',
      label: '促销政策',
      disabled: false,
      placeholder: '请选择促销政策',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-policy',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'jms-companystaff',
    },
    {
      type: 'datepicker',
      name: 'date',
      label: '收款日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM-DD HH:mm:ss',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      showTime: true,
      placeholder: '请选择收款日期',
    },
    {
      type: 'input',
      name: 'mark',
      label: '备注',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写备注',
    },
  ],
  rules: {
    franchisee_id: [{ required: true, message: '请填输入加盟商' }],
    date: [{ required: true, message: '请填输入收款日期' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    franchisee_id: null,
    price: null,
    cz_flje: null,
    sk_type_id: null,
    cxzc_id: null,
    staff_id: null,
    date: null,
    mark: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '充值记录管理',
  addModalTitle: '新建充值记录',
  updateTitle: '修改充值记录',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    id: 'id',
  },
  delete: {
    czrecord_id: 'id',
  },
  recover: {
    id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
  },
  {
    title: '充值编码',
    width: 150,
    dataIndex: 'code',
    fixed: 'left',
    checked: false,
  },
  {
    title: '促销政策ID',
    width: 150,
    dataIndex: 'id',
    checked: false,
  },
  {
    title: '加盟商',
    width: 150,
    dataIndex: 'franchisee__name',
    checked: false,
  },
  {
    title: '收款金额',
    width: 150,
    dataIndex: 'price',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '返利金额',
    width: 150,
    dataIndex: 'cz_flje',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '促销政策',
    width: 150,
    dataIndex: 'cxzc__name',
    checked: true,
  },
  {
    title: '支付方式',
    width: 150,
    dataIndex: 'sk_type_id',
    checked: false,
  },
  {
    title: '收款时间',
    width: 150,
    dataIndex: 'date',
    checked: true,
    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    checked: true,
    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '备注',
    width: 150,
    dataIndex: 'mark',
    checked: true,
  },

  {
    title: '加盟商编号',
    width: 150,
    dataIndex: 'franchisee__code',
    checked: false,
  },
  {
    title: '员工编号',
    width: 150,
    dataIndex: 'staff__code',
    checked: false,
  },
  {
    title: '名称',
    width: 150,
    dataIndex: 'staff__name',
    checked: false,
  },
  {
    title: '执行人',
    width: 150,
    dataIndex: 'staff_id',
    checked: false,
  },
  {
    title: '收款方式编码',
    width: 150,
    dataIndex: 'sk_type__code',
    checked: false,
  },
  {
    title: '收款方式',
    width: 150,
    dataIndex: 'sk_type__name',
    checked: false,
  },
  {
    title: '促销政策',
    width: 150,
    dataIndex: 'cxzc_id',
    checked: false,
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    checked: false,
    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '是否可用',
    width: 150,
    dataIndex: 'is_active',
    checked: false,
    cellComponent: 'boolean',
    name1: '可用',
    name2: '禁用',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  // slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_franchisee_c_z_record_list,
    addData: create_franchisee_c_z_record,
    updateData: None,
    removeData: delete_franchisee_c_z_record,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
